import { RouterState }          from "connected-react-router";
import React, {
  memo,
  useEffect,
  useState
}                               from 'react';
import {
  useDispatch,
  useSelector
}                               from "react-redux";
import DoExportComponent        from "../components/exports/DoExportComponent";
import CONSTANTS                from '../constants/exporting';
import { isInsideTimeBounds }   from "../hooks/useGettimelineForPane";
import { ApplicationState }     from "../store";
import { getBookmarksInfo }     from "../store/API/actions";
import { APIState }             from "../store/API/types";
import { setSelectedItems }     from "../store/bookmarks/actions";
import {
  BookmarkExportFormType,
  BookmarkState
}                               from "../store/bookmarks/types";
import { BrowseState }          from "../store/browse/types";
import { CamerasState }         from "../store/cameras/types";
import { triggerExportAVIList } from "../store/layouts/actions";
import { LayoutState }          from "../store/layouts/types";
import {
  changeExportsMode,
  doExportFiles,
  setEndPoint,
  setStartPoint
}                               from "../store/recordings/actions";
import { RecordingState }       from "../store/recordings/types";
import { TimelineState }        from "../store/timeline/types";
import { Routes }               from '../types';
import {
  chooseService,
  getCameraFromList
} from "../utils";

const {
  START_TIME_MORE_THAN_END,
  CHECK_START_TIME,
  CAMERA_IS_NOT_AVAILABLE,
  SELECT_ANY_PANE,
  NOT_ENOUGH_RIGHTS_EXPORT_VIDEO,
  NOT_ENOUGH_RIGHTS_EXPORT_BOOKMARK,
  SELECT_BOOKMARK_TO_UPDATE,
  SELECT_BOOKMARK_TO_DELETE,
  SET_BOOKMARK_INSIDE_TIMEBOUNDS
} = CONSTANTS;


const addMessage = (messages: string[], message: string) => {
  const ind = messages.indexOf(message);
  if (ind === -1) messages.push(message);
};

const removeMessage = (messages: string[], message: string) => {
  const ind = messages.indexOf(message);
  if (ind !== -1) messages.splice(ind, 1)
};


const DoExportContainer = () => {
  const dispatch = useDispatch();
  const {exportAVIListOpened, checkedPane} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {currentCameras} = useSelector<ApplicationState, CamerasState>(state => state.cameras);
  const {time} = useSelector<ApplicationState, TimelineState>(state => state.timeline);
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {bookmarks, selected} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
  const {mode, startPoint, endPoint} = useSelector<ApplicationState, RecordingState>(state => state.recording);
  const {bkmsInfo, cameras} = useSelector<ApplicationState, APIState>(state => state.API);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const [messages, setMessages] = useState([]);

  const isBookmarks = location.pathname === Routes.bookmarks;
  const panes = isBookmarks ? bookmarks : browsePanes;
  const locationPathname = location.pathname.slice(1);

  // const duration = CONFIG.exporting[mode].maxDuration;

  let title = typeof checkedPane === 'number' && panes[checkedPane]
    ? isBookmarks
      ? panes[checkedPane].camName
        ? panes[checkedPane].camName
        : ''
      : currentCameras[checkedPane]
        ? currentCameras[checkedPane].name
        : ''
    : '';

  const closeHandler = () => dispatch(triggerExportAVIList());

  const applyExport = (data: BookmarkExportFormType) => {
    if (startPoint && typeof checkedPane === 'number') {
      const startTime = endPoint ? Math.min(startPoint, endPoint) : Math.min(startPoint, time);
      const endTime = endPoint ? Math.max(startPoint, endPoint) : Math.max(startPoint, time);
      dispatch(doExportFiles(startTime, endTime - startTime, checkedPane, data, locationPathname, selected));
    }
  };

  const modifyMessage = (newMessages: string[], value: string, condition: any) => {
    condition
      ? addMessage(newMessages, value)
      : removeMessage(newMessages, value)
  };

  const checkDuration = (newMessages: string[]) => {
    if (!startPoint) return;

    const startTime = endPoint ? Math.min(startPoint, endPoint) : Math.min(startPoint, time);
    const endTime = endPoint ? Math.max(startPoint, endPoint) : Math.max(startPoint, time);

    // startTime && endTime && Math.abs(startTime - endTime) > duration
    //     ? addMessage(newMessages,MAXIMUM_DURATION + ' 10 min')
    //     : removeMessage(newMessages, MAXIMUM_DURATION + ' 10 min')

  };

  const isCanExport = () => {
    let canExportBookmarks = true,
      canExportVideo = true;
    if (panes && typeof checkedPane === 'number' && panes[checkedPane] !== null && typeof panes[checkedPane] !== 'undefined') {
      const cam = getCameraFromList(cameras, panes[checkedPane]?.id);
      canExportBookmarks = isBookmarks
        ? cam?.can_export_bookmarks
        : currentCameras[checkedPane] ? currentCameras[checkedPane].can_export_bookmarks : '';
      canExportVideo = isBookmarks
        ? cam?.can_export_video
        : currentCameras[checkedPane] ? currentCameras[checkedPane].can_export_video : '';
    }
    return [canExportBookmarks, canExportVideo];
  };

  const updateMessage = () => {
    const videoLoaded = panes && typeof checkedPane === 'number' && panes[checkedPane] ? !!panes[checkedPane] : false;
    const [canExportBookmarks, canExportVideo] = isCanExport();
    const newMessages = [...messages];
    modifyMessage(newMessages, START_TIME_MORE_THAN_END, (startPoint && endPoint && startPoint > endPoint));
    modifyMessage(newMessages, CHECK_START_TIME, !startPoint);
    modifyMessage(newMessages, SELECT_ANY_PANE, !(typeof checkedPane === 'number'));
    modifyMessage(newMessages, CAMERA_IS_NOT_AVAILABLE, !videoLoaded);

    const isInsideTimestrip = (mode === 'updateBookmark' || mode === 'deleteBookmark' || mode === 'avi' || mode === 'bookmarks')
      ? true
      : mode === 'createBookmark'
        ? panes && typeof checkedPane === 'number'
          && panes[checkedPane]
          && panes[checkedPane].timestrips && startPoint && isInsideTimeBounds(panes[checkedPane].timestrips, startPoint)
        : false;
    modifyMessage(newMessages, SET_BOOKMARK_INSIDE_TIMEBOUNDS, !isInsideTimestrip);
    modifyMessage(newMessages, SELECT_BOOKMARK_TO_UPDATE, selected.length < 1 && mode === 'updateBookmark');
    modifyMessage(newMessages, SELECT_BOOKMARK_TO_DELETE, selected.length < 1 && mode === 'deleteBookmark');

    chooseService(
      () => {
        if (mode === 'avi' && typeof checkedPane === 'number') {
          modifyMessage(newMessages, NOT_ENOUGH_RIGHTS_EXPORT_VIDEO, !canExportVideo);
          modifyMessage(newMessages, NOT_ENOUGH_RIGHTS_EXPORT_BOOKMARK, false);
        } else if (mode === 'bookmarks' && typeof checkedPane === 'number') {
          modifyMessage(newMessages, NOT_ENOUGH_RIGHTS_EXPORT_BOOKMARK, !canExportBookmarks);
          modifyMessage(newMessages, NOT_ENOUGH_RIGHTS_EXPORT_VIDEO, false);
        }
      },
      () => null
    )

    // checkDuration(newMessages);

    setMessages(newMessages);
  };

  useEffect(() => {
    updateMessage();
  }, [startPoint, endPoint, checkedPane, time, mode, browsePanes]);

  useEffect(() => {
    chooseService(
      () => {
        if (startPoint && !endPoint) {
          if (time < startPoint) {
            onChangeEndTime(new Date(startPoint));
            onChangeStartTime(new Date(time));
          } else {
            onChangeEndTime(new Date(time));
          }
        }
      },
      () => {
        if (startPoint && !endPoint) {
          onChangeCayugaTime(new Date(time))
        }
      }
    )
    return () => {
      chooseService(
        () => null,
        () => dispatch(setSelectedItems([]))
      );
    };
  }, [exportAVIListOpened]);

  const onChangeStartTime = (newStartTime: Date) => {
    const newStartTimeNumber = newStartTime.valueOf();
    dispatch(setStartPoint(newStartTimeNumber));
  };

  const onChangeEndTime = (newEndTime: Date) => {
    const newEndTimeNumber = newEndTime.valueOf();
    dispatch(setEndPoint(newEndTimeNumber));
  };

  const onChangeCayugaTime = (newTime: Date) => {
    const newTimeNumber = newTime.valueOf();
    dispatch(setStartPoint(newTimeNumber));
    dispatch(setEndPoint(newTimeNumber));
  }

  const triggerMode = (newMode: string) => {
    if (mode === newMode) return;
    if (newMode === 'bookmarks') dispatch(getBookmarksInfo());
    dispatch(changeExportsMode(newMode))
  };

  return (
    <>
      {
        exportAVIListOpened &&
        <DoExportComponent
          closeHandler={closeHandler}
          applyExport={applyExport}
          triggerMode={triggerMode}
          mode={mode}
          onChangeStartTime={onChangeStartTime}
          onChangeEndTime={onChangeEndTime}
          onChangeCayugaTime={onChangeCayugaTime}
          startTime={startPoint ? new Date(startPoint) : null}
          endTime={endPoint ? new Date(endPoint) : null}
          timelineTime={time}
          warningMessage={messages}
          title={title}
          bkmsInfo={bkmsInfo}
        />
      }
    </>
  )
};

export default memo(DoExportContainer);